import Header from "../../components/Header/Header";
import "./index.scss";
import { SvgIcon } from "../../components/SvgIcon";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo } from "react";
import { IS_MOBILE } from "@/utils/tool";
import { getUser } from "@/api/config";
import { message } from "antd";
import useQuit from "@/hooks/useQuit";
/**
 *
 * 个人中心
 * @returns
 */
const menuList = [
  {
    icon: "icon-wodedingdan",
    title: "我的订单",
    href: "order",
    mainPath: "order",
  },
  {
    icon: "icon-fapiaoguanli",
    title: "发票管理",
    href: "invoice/all",
    mainPath: "invoice",
  },
  //   {
  //     icon: "icon-dengjidan",
  //     title: "登记单管理",
  //     href: "registration",
  //     mainPath: "registration",
  //   },
];
const Personal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { quit } = useQuit();
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();

  const user = useMemo(() => {
    const _user = localStorage.getItem("user");
    return JSON.parse(_user);
  }, []);

  useEffect(() => {
    const userInfo = localStorage.getItem("user");
    if (userInfo) {
      if (location.pathname === "/personal") {
        navigate("order");
      }
    } else {
      navigate(`/login?goto=${encodeURIComponent(location.pathname)}`);
    }
  }, [location.pathname]);

  useEffect(() => {
    const user = getUser();
    if (user?.temporary) {
      messageApi.error(t("为了您的账号安全，请验证登录"), () => {
        quit("/personal/order");
      });
      return;
    }
  }, []);
  if (IS_MOBILE) {
    return (
      <div className="personal-mobile-blocked">
        <Header title={t("个人中心")} />
        <div className="personal-mobile-blocked__message">
          <SvgIcon
            icon="icon-liulanqi"
            width="80"
            height="80"
            style={{ fill: "var(--kx-fill-4)" }}
          />
          <span>
            {t(
              "尊敬的客户，感谢您使用PubLink服务。当前手机浏览器访问服务正在维护中，暂时无法登录，请使用电脑端登录。"
            )}
          </span>
        </div>
      </div>
    );
  }
  return (
    <div
      className={`personal-wrapper ${
        IS_MOBILE ? "mobile-personal-wrapper" : ""
      }`}
    >
      {contextHolder}
      <Header title={t("个人中心")}></Header>
      {IS_MOBILE && (
        <>
          <div className="mobile-user-info">
            {t("用户")}：{user?.phone}
          </div>
          <div className="empty-area"></div>
        </>
      )}
      <section className="page-content-wrapper">
        <section className="left-menu">
          {menuList.map((item) => (
            <div
              className={`menu-item ${
                location.pathname.includes(item.mainPath) ? "active" : ""
              }`}
              key={item.icon}
              onClick={() => navigate(item.href)}
            >
              {!IS_MOBILE && (
                <span className="menu-icon">
                  <SvgIcon icon={item.icon} width="100%" height="100%" />
                </span>
              )}
              <span>{t(item.title)}</span>
            </div>
          ))}
        </section>
        <section className="right-content">
          <Outlet />
        </section>
      </section>
    </div>
  );
};

export default Personal;
